import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import ActorPage from "@/pages/actors/page";
import PlotAnalysisPage from "@/pages/features/page";
import GuidesPage from "@/pages/guides/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category", element: <CategoryPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "actors/:id", element: <ActorPage /> },
      { path: "features/plot-analysis", element: <PlotAnalysisPage /> },
      { path: "guides", element: <GuidesPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;